import {SimplePresentation} from "./SimplePresentationRunner";
import {Decadence} from "../../Decadence";


export class DecadenceSFSPresentation extends SimplePresentation {

    constructor() {
        super("SuperFreespinsPresentation", false);
    }

    shouldRun(): boolean {
        return Decadence.model.triggeredSuperFreeSpins;
    }

    buildTimeline() {
        const tl = this.tl;
        tl.add(() => {}, ">0.5");
        tl.add(() => {
            this.controller.setSkipCallback(() => this.tl.seek("skip", false));
        })

        const scatters = Decadence.reelView.getActiveSymbols().filter(s => s.name == "SSC");
        tl.add(() => {
            Decadence.soundPlayer.playSound("scatterPump");
        })
        tl.add(scatters.map(s => s.playScatterActivate()));

        const scatterCount = Decadence.reelView.getActiveSymbols().filter(s => s.name == "SC" || s.name == "SSC").length;

        tl.add(Decadence.transitionScreen.darken(0.2));
        tl.add(Decadence.transitionScreen.showFSUpgrade(scatterCount*5));
        tl.add(Decadence.reelView.playMonsterScreamSFS(), "<");
        tl.add(() => {
            Decadence.soundPlayer.playSound("sfsIntroStart");
        }, "<")

        tl.add(() => {}, ">1.5");
        tl.addLabel("skip");
        tl.add(() => {
            this.controller.setSkipCallback();
        })
        tl.add(() => {
            Decadence.keypadPlugin.setZeroBetSpinCounter(Decadence.model.data.freespinsLeft);
        }, ">0.5")

        tl.add(Decadence.transitionScreen.hide())

        tl.add(Decadence.reelView.clearLockedReels());
        tl.add(Decadence.reelView.activeteLockedReels())
    }
}

export class DecadenceRetriggerPresentation extends SimplePresentation {

    constructor() {
        super("RetriggerPresentation", false);
    }

    shouldRun(): boolean {
        return Decadence.model.isSuperFreeSpins && (Decadence.reelView.getActiveSymbols().filter(s => s.name.includes("SC")).length > 0);
    }

    buildTimeline() {
        const tl = this.tl;
        tl.add(() =>{}, ">0.5");
        const scatters = Decadence.reelView.getActiveSymbols().filter(s => s.name.includes("SC"));

        tl.add(() => {
            Decadence.soundPlayer.playSound("scatterPump");
        })
        tl.add(scatters.map(s => s.playScatterActivate()));

        tl.add(Decadence.transitionScreen.darken(0.2));
        tl.add(() => {
            Decadence.soundPlayer.playSound("sfsIntroStart");
        })
        tl.add(Decadence.transitionScreen.showFSRetrigger(scatters.length*5));
        tl.add(Decadence.reelView.playMonsterScreamSFS(), "<");
        tl.add(() => {
            this.controller.setSkipCallback(() => {
                this.tl.seek("skip", false);
            })
        })

        tl.add(() => {}, ">2.5");
        tl.addLabel("skip");
        tl.add(() => {
            this.controller.setSkipCallback();
        })
        tl.add(() => {
            Decadence.keypadPlugin.setZeroBetSpinCounter(Decadence.model.data.freespinsLeft);
        })
        tl.add(Decadence.transitionScreen.hide());
    }
}